// Operaciones · Cuadre de caja diario (lado sistema)
// Totales del día por medio de pago (efectivo/débito/crédito/webpay QR/online),
// nº de folios emitidos y ventas sin folio. Base para cruzar con Bsale.

import React, { useEffect, useState, useCallback } from 'react';
import { Card, Table, Space, Typography, Row, Col, Statistic, Button, DatePicker, Empty, Tag } from 'antd';
import { ReloadOutlined, DollarOutlined, FileDoneOutlined, FileExclamationOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import OpsV2 from '../../../../service/ops.service';
import { mensajeDeError } from '../../../../service/client';
import { useNotify } from '../../../../providers/NotificationProvider';

const { Text, Paragraph } = Typography;

const METODO_LABEL = {
  efectivo: 'Efectivo', debito: 'Débito', credito: 'Crédito',
  webpay_qr: 'Webpay QR (POS)', pos: 'POS (tarjeta)', gratuito: 'Gratuito',
  online_webpay: 'Online (Webpay)', sin_metodo: 'Sin método',
};

export default function CuadreCaja() {
  const notify = useNotify();
  const [dia, setDia] = useState(dayjs());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      setData(await OpsV2.cuadreDiario({ dia: dia?.format('YYYY-MM-DD') }));
    } catch (err) {
      notify.error(mensajeDeError(err, 'No se pudo cargar el cuadre'));
    } finally { setLoading(false); }
  }, [dia, notify]);

  useEffect(() => { cargar(); }, [cargar]);

  const t = data?.totales || {};

  return (
    <div>
      <Space style={{ marginBottom: 12, width: '100%', justifyContent: 'space-between' }} wrap>
        <Paragraph type="secondary" style={{ margin: 0 }}>
          Cuadre del día (hora Chile). Totales del sistema por medio de pago y folios emitidos.
        </Paragraph>
        <Space wrap>
          <DatePicker value={dia} onChange={setDia} allowClear={false} format="DD/MM/YYYY" />
          <Button type="primary" icon={<ReloadOutlined />} onClick={cargar} loading={loading}>Refrescar</Button>
        </Space>
      </Space>

      <Row gutter={12} style={{ marginBottom: 12 }}>
        <Col xs={12} md={6}><Card size="small"><Statistic title="Total del día" value={t.total?.monto ?? 0} prefix={<DollarOutlined />} formatter={v => `$${Number(v).toLocaleString('es-CL')}`} /><Text type="secondary">{t.total?.n ?? 0} ventas</Text></Card></Col>
        <Col xs={12} md={6}><Card size="small"><Statistic title="Online (Webpay)" value={t.online?.monto ?? 0} formatter={v => `$${Number(v).toLocaleString('es-CL')}`} /><Text type="secondary">{t.online?.n ?? 0} ventas</Text></Card></Col>
        <Col xs={12} md={6}><Card size="small"><Statistic title="Presencial (POS)" value={t.pos?.monto ?? 0} formatter={v => `$${Number(v).toLocaleString('es-CL')}`} /><Text type="secondary">{t.pos?.n ?? 0} ventas</Text></Card></Col>
        <Col xs={12} md={6}><Card size="small"><Statistic title="Folios emitidos" value={t.folios ?? 0} prefix={<FileDoneOutlined />} /><Text type={t.ventasSinFolio ? 'danger' : 'secondary'}>{t.ventasSinFolio ?? 0} ventas sin folio</Text></Card></Col>
      </Row>

      <Card title="Desglose por medio de pago" size="small">
        <Table
          rowKey="metodo" size="small" pagination={false} loading={loading}
          dataSource={data?.porMetodo || []}
          columns={[
            { title: 'Medio de pago', dataIndex: 'metodo', render: m => <Tag>{METODO_LABEL[m] || m}</Tag> },
            { title: 'N° ventas', dataIndex: 'n', align: 'right', width: 120 },
            { title: 'Monto', dataIndex: 'monto', align: 'right', width: 160, render: m => `$${(m || 0).toLocaleString('es-CL')}` },
          ]}
          summary={(rows) => {
            const n = rows.reduce((s, r) => s + r.n, 0);
            const m = rows.reduce((s, r) => s + r.monto, 0);
            return (
              <Table.Summary.Row>
                <Table.Summary.Cell><Text strong>Total</Text></Table.Summary.Cell>
                <Table.Summary.Cell align="right"><Text strong>{n}</Text></Table.Summary.Cell>
                <Table.Summary.Cell align="right"><Text strong>${m.toLocaleString('es-CL')}</Text></Table.Summary.Cell>
              </Table.Summary.Row>
            );
          }}
          locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin ventas ese día" /> }}
        />
      </Card>
    </div>
  );
}
